export const validateToken = (token: string) =>
  fetch("/api/account/team-token", {
    method: "POST",
    body: JSON.stringify({ token }),
    headers: { "Content-Type": "application/json" },
  }).then((r) => r.json());
